import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';

export default function Sites({ currentUser, setHeaderAction }) {
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null); // null | { ...site }
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try { setSites((await api.get('/sites')).data); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const openNew = useCallback(() => { setError(''); setModal({ nom: '', slug: '', actif: true }); }, []);
  useEffect(() => {
    if (!setHeaderAction) return undefined;
    setHeaderAction(<button className="page-action-btn" onClick={openNew}>+ Nouveau site</button>);
    return () => setHeaderAction(null);
  }, [openNew, setHeaderAction]);

  const save = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (modal.id) await api.put(`/sites/${modal.id}`, modal);
      else await api.post('/sites', modal);
      setModal(null);
      load();
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur');
    }
  };

  const remove = async (s) => {
    if (!window.confirm(`Supprimer le site « ${s.nom} » ?`)) return;
    try { await api.delete(`/sites/${s.id}`); load(); }
    catch (err) { alert(err.response?.data?.error || 'Erreur'); }
  };

  const canDelete = currentUser.role === 'super-admin';

  return (
    <div className="page-container">
      <div className="page-header-row">
        <div>
          <h2 className="page-title">Sites</h2>
          <p className="page-subtitle">{sites.length} site(s)</p>
        </div>
      </div>

      <div className="table-container">
        <table>
          <thead><tr><th>Nom</th><th>Slug</th><th>Statut</th><th></th></tr></thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={4} className="table-empty">Chargement…</td></tr>
            ) : sites.length === 0 ? (
              <tr><td colSpan={4} className="table-empty">Aucun site.</td></tr>
            ) : sites.map((s) => (
              <tr key={s.id}>
                <td>{s.nom}</td>
                <td style={{ color: 'var(--text-muted)' }}>{s.slug}</td>
                <td>{s.actif ? <span className="badge-pill badge-success">Actif</span> : <span className="badge-pill badge-error">Inactif</span>}</td>
                <td>
                  <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
                    <button className="btn-icon" title="Modifier" onClick={() => { setError(''); setModal({ ...s }); }}>✏️</button>
                    {canDelete && <button className="btn-icon delete" title="Supprimer" onClick={() => remove(s)}>🗑️</button>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{modal.id ? 'Modifier le site' : 'Nouveau site'}</h2>
              <button className="modal-close" onClick={() => setModal(null)}>✕</button>
            </div>
            <form onSubmit={save}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Nom *</label>
                  <input className="form-control" value={modal.nom} onChange={(e) => setModal({ ...modal, nom: e.target.value })} autoFocus />
                </div>
                <div className="form-group">
                  <label>Slug (optionnel — généré depuis le nom si vide)</label>
                  <input className="form-control" value={modal.slug || ''} onChange={(e) => setModal({ ...modal, slug: e.target.value })} />
                </div>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                  <input type="checkbox" checked={modal.actif !== false} onChange={(e) => setModal({ ...modal, actif: e.target.checked })} />
                  Site actif
                </label>
                {error && <div className="form-error" style={{ marginTop: 8 }}>{error}</div>}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn-secondary" onClick={() => setModal(null)}>Annuler</button>
                <button type="submit" className="btn-primary">Enregistrer</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
